import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../../core/alert/alert.service';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/components/common/messageservice';
import { Message } from 'primeng/components/common/message';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
  // messages: Array<any> = [];
  // private messageCounter = 0;

  // constructor(private alertService: AlertService) {
  // }

  // ngOnInit() {
  //   this.alertService.getMessage().subscribe(message => {
  //     console.log("message: ", message)
  //     const messageData = {key: this.messageCounter++, value: message};
  //     this.messages.push(messageData);
  //     setTimeout(() => {
  //       this.messages = this.messages.filter((data) => data.key !== messageData.key);
  //     }, 3000);
  //   });
  // }
  
  private subscription: Subscription;
  msgs: Message[] = [];

  constructor(
      private alertService: AlertService,
      private messageService: MessageService,
  ) { }

  ngOnInit() {
      this.subscription = this.alertService.getMessage().subscribe(message => {
          if (message.type == 'success') {
              this.showSuccess(message.text);
          }
          else if (message.type == 'error') {
              this.showError(message.text);
          }
      });
  }

  showSuccess(text) {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: text });

  }
  showError(text: string) {
      this.messageService.add({ severity: 'error', summary: 'Error !', detail: text });
  }
     
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/widgets/alert/alert.component.ts